import React, { useEffect } from 'react'
import { MemberProfileShort } from 'cwp-components/CWP Sections/MemberProfile/MemberProfileShort'
import { useGetShortProfiles } from 'common/hooks/useGetShortProfiles'

interface GetAdviceProps {
  id: string
  idName: 'area_id' | 'sub_area_id'
}
const GetAdvice = ({ id, idName }: GetAdviceProps) => {
  const { loadShortProfiles, shortProfiles, isShortProfilesLoading } =
    useGetShortProfiles('proSearch')

  useEffect(() => {
    loadShortProfiles(`${idName}=${id}`, 5)
  }, [id])

  return (
    <div className='relative shadow-[0px_4px_50px_0px_rgba(0,0,0,0.08)] w-full mx-auto pl-5 pr-5 pt-7 pb-7 md:pl-20 md:pr-20 md:pt-20 md:pb-20'>
      <div className='relative px-2.5 sm:px-4 md:p-6 lg:px-10 xl:px-16 2xl:px-20 box-border'>
        <h3 className='text-2xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-[#101828] leading-none tracking-wide'>
          Get advice today
        </h3>
        <p className='text-[#818285] text-sm md:text-base lg:text-lg font-medium md:font-bold leading-6 tracking-wide mt-3'>
          Connect with experienced lawyers now and get the expert advice you
          need.
        </p>
        {isShortProfilesLoading === false && shortProfiles.length === 0 ? (
          <p className='text-[#818285] text-center text-sm md:text-base lg:text-lg font-bold leading-6 tracking-wide mt-3'>
            {' '}
            No Profile found
          </p>
        ) : (
          <div className='w-full mx-auto max-w-[1690px] mt-4'>
            <div className='flex justify-center flex-wrap gap-7 md:justify-left my-2 md:my-3'>
              {shortProfiles.map((item) => (
                <MemberProfileShort
                  key={item.id}
                  profile={{
                    ...item,
                    membership_type: item?.membership_type,
                  }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default GetAdvice
